import React from 'react'
import Level from './Level.js'
import './App.css'

class App extends React.Component {
    render() {
        return (
            <div className='App'>
                <Level />
            </div> 
        ) 
    }
}

export default App